import React, { useState } from 'react';
import { FaBars, FaArrowRight, FaFingerprint } from 'react-icons/fa6';
import './Menu.scss';
import { useNavigate } from 'react-router-dom';

const Menu: React.FC = () => {
  // State to manage whether the menu drawer is open or closed
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  // Toggle the drawer open/closed
  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  // Scroll smoothly to a section (and close the drawer)
  const scrollToSection = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  // Función para abrir WhatsApp
  const openWhatsApp = () => {
    // Número sin espacios ni signos: 56926974928
    window.open('https://wkf.ms/43mTnyz', '_blank');
    setIsMenuOpen(false);
  };

  return (
    <div className="navbar-menu-outer-container">
      <nav className="web-page-menu-container">
        <div className="menu-header">
          <div className="logo-icon">
            <img
              alt="logo"
              className="logo-img"
              src={`${process.env.PUBLIC_URL}/logos/logo-48.png`}
            />
          </div>

          {/* Hamburger button (hidden on desktop; shown on mobile) */}
          <button
            className="hamburger-button"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <FaBars className={`hamburger-icon ${isMenuOpen ? 'open' : ''}`} />
          </button>
        </div>

        <ul className={`${isMenuOpen ? 'menu-open' : ''}`}>
          <li>
            <button className="volver-button" onClick={toggleMenu}>
              Volver
            </button>
          </li>
          <li>
            <a href="/#" onClick={() => scrollToSection('header')}>
              Inicio
            </a>
          </li>
          <li>
            <a href="/#" onClick={() => scrollToSection('who-we-are')}>
              Nosotros
            </a>
          </li>
          <li>
            <a href="/#" onClick={() => scrollToSection('features')}>
              Soluciones
            </a>
          </li>
          <li>
            <a href="/#" onClick={() => scrollToSection('pricing')}>
              Precios
            </a>
          </li>

          <li className="mobile-only">
            <button
              className="login-button-mobile"
              onClick={() => {
                navigate('/login');
                setIsMenuOpen(false);
              }}
            >
              <FaFingerprint className="fingerprint-icon" />
              Ingresar
            </button>
          </li>
          <li className="mobile-only">
            <button
              className="demo-button-mobile"
              onClick={openWhatsApp}
            >
              Demo <FaArrowRight />
            </button>
          </li>
        </ul>

        <div className="menu-buttons">
          <button
            onClick={() => navigate('/login')}
            className="login-button"
          >
            <FaFingerprint className="fingerprint-icon" />
            Ingresar
          </button>
          <button
            onClick={openWhatsApp}
            className="demo-button"
          >
            Demo <FaArrowRight />
          </button>
        </div>
      </nav>
    </div>
  );
};

export default Menu;
